/** API blob PDF 다운로드 */
export function downloadPdfBlob(data: BlobPart, filename: string) {
  const blob = new Blob([data], { type: 'application/pdf' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

/** axios blob 오류 메시지 추출 */
export async function getApiErrorMessage(error: any, fallback: string): Promise<string> {
  const status = error.response?.status;
  const data = error.response?.data;
  if (data instanceof Blob) {
    try {
      const text = await data.text();
      const json = JSON.parse(text);
      const msg = json.message || fallback;
      return status ? `${msg} (${status})` : msg;
    } catch {
      return status ? `${fallback} (${status})` : fallback;
    }
  }
  const msg = data?.message || error.message || fallback;
  return status ? `${msg} (${status})` : msg;
}
